import Link from 'next/link';
import {
  CardButton,
  CardSubtitle,
  CardTitle,
  StyledCard,
  StyledCardAction,
  StyledCardContent,
} from './DialogCard.styles';

type DialogCardProps = {
  id: string;
  onClick?: () => void;
  href?: string;
  isHighlighted?: boolean;
  cardTitle: string;
  cardSubtitle: string;
  cardButtonLabel: string;
  isExternalLink: boolean;
  customBackground: string;
};

/**
 * Props for configuring a dialog card component from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 *
 * @property {string} id - The unique identifier for the dialog card.
 * @property {function} onClick - The function to be called when the card is clicked.
 * @property {string} href - The URL to navigate to when the card is clicked.
 *
 */

export const DialogCard = ({
  id,
  onClick,
  href,
  isHighlighted,
  cardTitle,
  cardSubtitle,
  cardButtonLabel,
  customBackground = '',
}: DialogCardProps) => {
  return (
    <StyledCard
      customBackground={customBackground}
      data-testid={`dialog-card-${id}`}
      isHighlighted={isHighlighted}
    >
      <StyledCardContent>
        <CardTitle>{cardTitle}</CardTitle>
        <CardSubtitle>{cardSubtitle}</CardSubtitle>
      </StyledCardContent>
      <StyledCardAction>
        <CardButton
          size="small"
          variant="contained"
          disableElevation
          {...(onClick && {
            onClick,
          })}
          {...(href && {
            component: Link,
            href,
          })}
        >
          {cardButtonLabel}
        </CardButton>
      </StyledCardAction>
    </StyledCard>
  );
};
